import { InputHTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className, ...props }, ref) => {
    return (
      <div className="mb-4">
        {label && (
          <label className="mb-2 block text-xs font-bold uppercase text-gray-700">{label}</label>
        )}
        <input
          ref={ref}
          className={clsx(
            'input-field',
            {
              'border-system-red focus:border-system-red focus:ring-system-red': error,
            },
            className
          )}
          {...props}
        />
        {error && <p className="mt-1 text-xs text-system-red">{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
